<template>
  <i
    :class="[`unex-icon-${svg}`, className]"
    class="icon unex"
    :style="style"
    @click="handleClick()"
  ></i>
</template>

<script>
export default {
  props: {
    svg: {},
    size: {
      default: "normal"
    }
  },

  data() {
    return {
      className: this.$vnode.data.staticClass,
      style: this.$vnode.data.style
    };
  },

  methods: {
    handleClick() {
      this.$emit("click");
    }
  },

  mounted() {}
};
</script>
<style></style>
